import { Box, Card, IconButton } from '@mui/material'

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import WTypography from 'Components/whiteTypography'
import DoDisturbOnOutlinedIcon from '@mui/icons-material/DoDisturbOnOutlined'
import { DataGrid } from 'Components/LifeDataGrid'
import urls from 'utils/urls'
import { makeGetRequest } from 'utils/api'
import { makePostRequest } from 'utils/api'
import { Stack } from 'react-bootstrap'
import CreateObjectifsForm from 'containers/MesObjectifs/CreateObjectifsForm'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import { styled } from '@mui/material/styles'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 15,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 400 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 2,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
  },
}))

function ObjectIfsCard({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteUser = useSelector((store) => store.user)

  const navigate = useNavigate()
  const [selectedRows, setSelectedRows] = useState([])
  const [objectifsMetadata, setObjectifsMetaDeta] = useState({})
  const [objectifs, setObjectifs] = useState({
    count: 0,
    next: null,
    previous: null,
    results: [],
  })

  useEffect(() => {
    fetchMesObjectifsMetaData()
  }, [])
  useEffect(() => {
    if (objectifs.results.length > 0) {
      updateReports()
    }
  }, [objectifs.results.length])
  const columns = [
    {
      field: 'objectives_name',
      headerName: '',
      width: 210,
      editable: false,
      renderCell: (params) => {
        return (
          <Box>
            <Box>{params.row.objectives_name}</Box>
            <Box sx={{ color: '#ffffffa1' }}>
              {convertToUserDateFormate(siteUser.user, params.row.creation_date)} -{' '}
              {convertToUserDateFormate(siteUser.user, params.row.date_objectives)}
            </Box>
          </Box>
        )
      },
    },
    {
      field: 'categorie',
      headerName: '',
      width: 80,
      editable: false,
      renderCell: (params) => {
        return (
          <Box sx={{ flexGrow: 1 }}>
            <BorderLinearProgress variant="determinate" value={100} />
          </Box>
        )
      },
    },
  ]
  const fetchMesObjectifsMetaData = async () => {
    const response = await makeGetRequest(urls.fetchMesObjectifsMetaData, {}, true)
    if (response.status === 200) {
      const domains = []
      const frequency = []
      const predefinedObjectives = []
      const status = [{ label: 'En cours' }, { label: 'Annulé' }, { label: 'reussite' }]
      response.data.domains.forEach((v) => {
        domains.push({ label: v.domain, id: v.id })
      })
      response.data.frequency.forEach((v) => {
        frequency.push({ label: v.name_of_periodicity, id: v.id })
      })
      response.data.predefined_objectives.forEach((v) => {
        predefinedObjectives.push({
          label: v.objectives_name,
          id: v.id,
          domain: v.domain,
          value: v.value_format,
        })
      })
      setObjectifsMetaDeta({
        domains,
        frequency,
        predefinedObjectives,
        status,
      })
    }
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('syntheseTemps.selectOperationAlert'))
    } else {
      const response = await makePostRequest(
        urls.deleteUserObjectIfs,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
        updateReports()
      }
    }
  }

  return (
    <>
      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1 no-drag" onClick={() => navigate('/mesobjectifs')}>
          <WTypography component={'span'} variant="h6">
            {t('syntheseTemps.objectivesTitle')}
          </WTypography>
          <WTypography component={'span'} variant="h6">
            {oldData.length}
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {t('syntheseTemps.objectivesSubtitle')}
          </WTypography>

          <Stack
            className="no-drag"
            style={{
              flexDirection: 'row',
              justifyContent: 'flex-end',
            }}
          >
            <CreateObjectifsForm
              objectifsMetadata={objectifsMetadata}
              setObjectifs={setObjectifs}
              buttonIcon={true}
            />

            <IconButton sx={{ color: 'white' }} onClick={deleteBulkOperations}>
              <DoDisturbOnOutlinedIcon />
            </IconButton>
          </Stack>
        </Box>

        <Box minWidth={3} mb={6} height={'100%'} borderTop={'1px solid white'}>
          {oldData.length > 0 && (
            <div
              style={{
                height: '100%',
                width: '100% ',
                background: 'unset',
                borderRadius: '5px',
                '.MuiDataGridMain': {
                  color: 'white',
                },
              }}
            >
              <DataGrid
                className="no-drag"
                style={{
                  color: 'white',
                  border: 'unset',
                }}
                sx={{
                  '.MuiDataGrid-cellCheckbox': {
                    color: 'white',
                  },
                  '.MuiDataGrid-cell': {
                    borderBottom: 'unset',
                    maxHeight: 'fit-content !important',
                    minHeight: 'fit-content !important',
                    whiteSpace: 'unset !important',
                    padding: '4px 2px',
                  },
                  '.MuiCheckbox-root': {
                    color: 'white',
                  },
                  '.Mui-checked': {
                    color: 'white !important',
                  },
                  '.MuiDataGrid-row': {
                    maxHeight: 'fit-content !important',
                    minHeight: 'fit-content !important',
                    borderBottom: '1px solid #656565',
                  },
                  '& .MuiDataGrid-columnHeaders': { display: 'none' },
                  '& .MuiDataGrid-virtualScroller': { overflow: 'unset', marginTop: '0!important' },
                }}
                rows={oldData}
                columns={columns}
                rowsPerPageOptions={[10, 20, 40, 80, 100]}
                pagination
                onSelectionModelChange={(itm) => setSelectedRows([...itm])}
                paginationMode="server"
                checkboxSelection
                disableSelectionOnClick
                hideFooter
                hideFooterPagination
                disableColumnMenu
                columnHeaderHeight={0}
              />
            </div>
          )}
        </Box>
      </Card>
    </>
  )
}

export default ObjectIfsCard
